import { useEffect } from 'react';
import { DateRange } from '../../models/monitor/DateRange';
import { getDateRange } from '../../api/services/monitor/MonitorService';
import { StandardPeriodType } from '../../types/filters/StandardPeriodType';
import { calculateDefaultDateRange } from '../../helpers/filters/DateRangeHelper';

const useDateRange = (
  projectId: number,
  setDateRange: (dateRange: DateRange | null) => void,
  setRange: (range: (Date | null)[]) => void,
  setSelectedPeriod: (period: StandardPeriodType | null) => void
) => {
  useEffect(() => {
    if (!projectId || projectId === 0) {
      return;
    }

    getDateRange(projectId)
      .then((dateRange) => {
        const oldestDateUTC = new Date(dateRange.oldestDate);
        const newestDateUTC = new Date(dateRange.newestDate);

        const oldestDateLocal = new Date(oldestDateUTC.toLocaleDateString('sv-SV'));
        const newestDateLocal = new Date(newestDateUTC.toLocaleDateString('sv-SV'));

        if (isNaN(oldestDateLocal.getTime()) || isNaN(newestDateLocal.getTime())) {
          console.error('Invalid dates after conversion:', { oldestDateLocal, newestDateLocal });
          return;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        setDateRange({
          oldestDate: oldestDateLocal,
          newestDate: today,
        });

        const { period, range } = calculateDefaultDateRange(oldestDateLocal);

        setRange(range);
        setSelectedPeriod(period);
      })
      .catch((error) => {
        console.error('Failed to get date range:', error);
      });
  }, [projectId]);
};

export default useDateRange;
